import { memo } from 'react';
const SvgArrowRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="arrow-right_svg__feather arrow-right_svg__feather-arrow-right"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);
const Memo = memo(SvgArrowRight);
export default Memo;
